<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../core/config/constants.js'
</script>

<template>
  <div class="document-page">
    <!-- Header -->
    <header class="document-header">
      <div class="header-content">
        <RouterLink :to="{ name: ROUTES.HOME }" class="back-link">
          <svg
            viewBox="0 0 24 24"
            width="20"
            height="20"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M5 12H19M12 5l7 7-7 7" />
          </svg>
          <span>חזרה</span>
        </RouterLink>
        <RouterLink :to="{ name: ROUTES.HOME }" class="logo-wrapper">
          <img src="@/assets/logo/logo_76.png" alt="GoFood" class="logo-img" />
          <span class="logo-text">GoFood</span>
        </RouterLink>
      </div>
    </header>

    <!-- Content -->
    <main class="document-main">
      <article class="document-content">
        <h1>תקנון שימוש – מערכת סחר B2B (GoFood)</h1>

        <p>
          מערכת זו (אתר/אפליקציה/ממשקי הזמנה דיגיטליים), המופעלת ומנוהלת על ידי רוסמן לוגיסטיקה בע״מ
          (להלן: <strong>"רוסמן"</strong> / <strong>"החברה"</strong>), מיועדת לשימוש
          <strong>עסקי (B2B)</strong> בלבד, ללקוחות עסקיים כמפורט להלן.
        </p>

        <h2>0. מבוא, הסכמה לתנאים והגדרות</h2>
        <p>0.1. תקנון זה מסדיר את תנאי השימוש במערכת (להלן: <strong>"המערכת"</strong>).</p>
        <p>
          0.2. השימוש במערכת כפוף לתקנון זה ולמדיניות הפרטיות של החברה כפי שתפורסם מעת לעת במערכת
          (להלן יחד: <strong>"המסמכים המחייבים"</strong>).
        </p>
        <p>
          0.3. כל שימוש במערכת מהווה הסכמה מלאה לתקנון זה. אם אינך מסכים לתנאים כולם או חלקם – אין
          לעשות שימוש במערכת.
        </p>
        <p>
          0.4.
          <strong
            >הרשמה למערכת ו/או פתיחת חשבון ו/או שימוש בפועל במערכת מהווים אישור והסכמה של הלקוח ושל
            המשתמש המורשה לתקנון זה וליתר המסמכים המחייבים, והתחייבות לפעול על פיהם.</strong
          >
        </p>
        <p>
          0.5. החברה רשאית לעדכן תקנון זה בכל עת; נוסח התקנון המעודכן ייכנס לתוקף במועד פרסומו
          במערכת.
        </p>
        <p>0.6. הגדרות:</p>
        <ul>
          <li>
            <strong>"לקוח"</strong> – תאגיד/עוסק מורשה/שותפות/עמותה/גוף עסקי אחר, הרוכש מוצרים
            לצרכים עסקיים.
          </li>
          <li>
            <strong>"משתמש מורשה"</strong> – אדם מטעם הלקוח שהוסמך לבצע פעולות במערכת (לרבות הזמנות,
            צפייה במחירים, ניהול משתמשים).
          </li>
          <li>
            <strong>"חשבון"</strong> – סביבת הלקוח במערכת, לרבות הרשאות, תנאי תשלום, כתובות אספקה,
            רשימות פריטים ומחירון.
          </li>
          <li>
            <strong>"מוצרים"</strong> – כל מוצרי המזון, מוצרי הצריכה ו/או השירותים המוצעים במערכת.
          </li>
          <li>
            <strong>"הזמנה"</strong> – בקשה מחייבת מצד הלקוח לרכישת מוצרים באמצעות המערכת, בכפוף
            לאישור החברה כמפורט להלן.
          </li>
        </ul>

        <h2>1. ייעוד המערכת ושירותים</h2>
        <p>
          1.1. המערכת מהווה פלטפורמת הזמנה וניהול קשר מסחרי B2B מול החברה (לרבות: חיפוש מוצרים,
          צפייה במחירונים עסקיים/הנחות, ביצוע הזמנות, מעקב אספקה, קבלות/חשבוניות, תמיכה ושירות).
        </p>
        <p>
          1.2. החברה רשאית להוסיף/לגרוע שירותים, לשנות מסכים, תהליכי הזמנה, אינטגרציות ו/או מדיניות
          תפעול – לפי שיקול דעתה, ללא הודעה מוקדמת.
        </p>
        <p>
          1.3. החברה רשאית להפסיק או להגביל שימוש במערכת במקרה של הפרת תקנון זה, חשד לשימוש בלתי
          מורשה, או משיקולי אבטחה/ציות/אשראי.
        </p>

        <h2>2. כשירות לשימוש, פתיחת חשבון והרשאות</h2>
        <p>
          2.1. השימוש במערכת מותר ללקוחות עסקיים בלבד. החברה רשאית לדרוש מסמכים לצורך פתיחת חשבון
          (כגון: פרטי חברה, ח.פ./עוסק, כתובת, פרטי מורשי חתימה, אישורי ניכוי מס במקור וכד').
        </p>
        <p>
          2.2. הלקוח מצהיר כי המשתמשים המורשים פועלים מטעמו ובסמכותו, וכי כל פעולה במערכת באמצעות
          חשבון הלקוח תחייב את הלקוח לכל דבר ועניין.
        </p>
        <p>
          2.3. הלקוח אחראי לשמירת סודיות פרטי ההתחברות, לניהול הרשאות פנימי (הוספה/הסרה/הגבלת
          משתמשים), ולעדכון מיידי של החברה במקרה של חשד לשימוש בלתי מורשה.
        </p>
        <p>
          2.4. החברה אינה אחראית לנזק הנובע משימוש בלתי מורשה בפרטי גישה שנמסרו/דלפו אצל הלקוח, אלא
          אם הדין קובע אחרת.
        </p>

        <h2>3. קטלוג, זמינות, תיאורים ותמונות</h2>
        <p>
          3.1. תיאורי מוצרים, מפרטים, תמונות וסימונים מוצגים לנוחות. ייתכנו פערים בין המוצג במערכת
          לבין המוצר בפועל (לרבות שינוי אריזה/מקט/יצרן), בכפוף לדין.
        </p>
        <p>
          3.2. זמינות מלאי אינה מובטחת. החברה רשאית לספק הזמנה במלואה או בחלקה, לספק מוצרים חלופיים
          (אם הוגדרה מדיניות חלופות), או לבטל פריטים חסרים.
        </p>
        <p>
          3.3. ככל שהמערכת מאפשרת "מוצרים במשקל" – החיוב ייקבע לפי המשקל בפועל באיסוף/ליקוט ובהתאם
          לחשבונית.
        </p>

        <h2>4. מחירים, הנחות, מע״מ וחשבוניות</h2>
        <p>
          4.1. המחירים המוצגים ללקוח במערכת הם מחירים עסקיים בהתאם להסכמים/מחירונים הרלוונטיים
          לחשבון הלקוח, ועלולים להשתנות מעת לעת.
        </p>
        <p>
          4.2. אלא אם צוין אחרת – המחירים כוללים מע״מ כדין. החשבונית/תעודת המשלוח היא המסמך הקובע
          לצורך חיוב.
        </p>
        <p>
          4.3. החברה רשאית לתקן טעויות בתמחור/שיוך מחירון; במקרה כזה תודיע ללקוח ותאפשר ביטול/אישור
          מחדש לפי נסיבות העניין.
        </p>

        <h2>5. ביצוע הזמנה, אישור הזמנה ומינימום הזמנה</h2>
        <p>
          5.1. שליחת הזמנה במערכת מהווה הצעה מחייבת מצד הלקוח. הזמנה תיחשב מאושרת רק לאחר אישור
          החברה (אוטומטי או ידני), בהתאם למדיניות אשראי, מלאי, זמינות לוגיסטית ושיקולי ציות.
        </p>
        <p>5.2. החברה רשאית לקבוע מינימום הזמנה, מגבלות כמות, הקצאות מלאי, או תנאים מיוחדים.</p>
        <p>
          5.3. החברה רשאית לסרב לאשר הזמנה, לעכב אספקה או להתנות אספקה בתשלום מראש – בין היתר במקרה
          של חריגות אשראי/פיגור תשלומים/חשד להונאה/אי-התאמות בפרטים.
        </p>

        <h2>6. תנאי תשלום, אשראי ופיגורים</h2>
        <p>
          6.1. אמצעי התשלום ותנאי האשראי יהיו לפי מה שמוגדר לחשבון הלקוח: כרטיס אשראי, העברה בנקאית,
          הוראת קבע, שוטף+X וכד'.
        </p>
        <p>
          6.2. הלקוח מתחייב לשלם במועדים שנקבעו. החברה רשאית להשהות אספקות ו/או לחסום הזמנות חדשות
          במקרה של פיגור/חריגה.
        </p>
        <p>
          6.3. ככל שייקבע בהסכם מסחרי/במסמכי החשבון – החברה רשאית לגבות ריבית פיגורים/הצמדה והוצאות
          גבייה סבירות.
        </p>

        <h2>7. דמי משלוח וחיובים נלווים</h2>
        <p>
          7.1. דמי משלוח/ליקוט/טיפול/קירור/הקפאה (אם קיימים) יוצגו לפני אישור סופי של ההזמנה, או
          יוגדרו בהסכם המסחרי מול הלקוח.
        </p>
        <p>7.2. דמי משלוח אינם כוללים תשר ואינם מועברים אישית לשליח.</p>

        <h2>8. אספקה, מסירה ובדיקת הסחורה</h2>
        <p>
          8.1. אספקה תתבצע לכתובת כפי שהוגדרה לחשבון הלקוח, במועדים משוערים בהתאם ליכולת לוגיסטית.
        </p>
        <p>8.2. במסירה ללקוח/נציגו – הלקוח מתבקש לבצע בדיקה מיידית של כמות/אריזה/נזק חיצוני.</p>
        <p>
          8.3. חתימה על תעודת משלוח/מסירה (דיגיטלית או פיזית) תהווה ראיה לקבלה, אלא אם נרשמה
          הסתייגות מפורשת במועד המסירה.
        </p>
        <p>
          8.4. ככל שהלקוח מבקש השארת סחורה ללא נוכחות – האחריות לנזק/אובדן לאחר ההשארה תחול על
          הלקוח, אלא אם הדין מחייב אחרת.
        </p>
        <p>
          8.5. החברה אינה מתחייבת לעמידה מדויקת בשעת אספקה, והלקוח לא יהיה פטור מתשלום בשל איחור,
          אלא אם הוסכם אחרת בכתב.
        </p>

        <h2>9. שינוי/ביטול הזמנה</h2>
        <p>
          9.1. שינוי/ביטול הזמנה יתאפשרו בהתאם לסטטוס ליקוט/הכנה/שילוח ובהתאם למדיניות החברה כפי
          שתיקבע מעת לעת.
        </p>
        <p>
          9.2. בעסקאות B2B אין תחולה אוטומטית של מנגנוני ביטול עסקה צרכניים, ולכן שינוי/ביטול הם לפי
          ההסכם המסחרי ותקנון זה, אלא אם הדין מחייב אחרת במפורש.
        </p>

        <h2>10. החזרות, זיכויים ומוצרים פגומים</h2>
        <p>
          10.1. הלקוח מתחייב לדווח לשירות הלקוחות בתוך זמן קצר וסביר ממועד המסירה, ובכל מקרה לא
          יאוחר מ-24 שעות עבור מוצרי מזון/קירור/הקפאה/מתכלים, אלא אם הוסכם אחרת בכתב.
        </p>
        <p>10.2. החזרות יבוצעו רק באישור החברה ובהתאם להנחיותיה.</p>
        <p>
          10.3. מוצרים מתכלים/מזון/קירור/הקפאה: ככלל, החזרה תתאפשר רק במקרה של פגם מהותי/אי-התאמה
          מוכחת ובכפוף לבדיקה.
        </p>
        <p>
          10.4. החברה רשאית לזכות/להחליף/להשלים חוסרים לפי שיקול דעתה ובהתאם לדין ולהסכמים המסחריים;
          מסמכי הזיכוי/החשבונית יהיו המסמכים הקובעים.
        </p>

        <h2>11. שמירת בעלות</h2>
        <p>
          11.1. הבעלות במוצרים תישאר בידי החברה עד לפרעון מלא של התמורה בגינם, ככל שהדבר מותר לפי
          דין ובהתאם להסכמים המסחריים.
        </p>

        <h2>12. שימוש אסור, אבטחה והגנת המערכת</h2>
        <p>
          12.1. חל איסור לבצע פעולות העלולות לפגוע במערכת: חדירה, סריקות, עקיפת מנגנוני אבטחה, הנדסה
          לאחור, שאיבת נתונים אוטומטית ללא הרשאה, או שימוש החורג מהרשאות המשתמש.
        </p>
        <p>
          12.2. החברה רשאית לחסום חשבונות/כתובות IP, להגביל קצב, לדרוש אימות נוסף, ולנקוט אמצעים
          סבירים למניעת הונאות.
        </p>

        <h2>13. פרטיות וקבצי Cookies</h2>
        <p>
          13.1. החברה תפעל בהתאם לדיני הגנת הפרטיות ואבטחת מידע החלים בישראל, לרבות חובת היידוע בעת
          איסוף מידע אישי.
        </p>
        <p>
          13.2. המערכת עשויה לעשות שימוש בקבצי Cookies וטכנולוגיות דומות לצרכי תפעול, אבטחה,
          אנליטיקה והתאמה; חסימת Cookies חיוניים עלולה לפגוע בשירות.
        </p>

        <h2>14. שליחת חומרים פרסומיים, דיוור ומסרים שיווקיים</h2>
        <p>
          14.1. "דבר פרסומת" – כהגדרתו בסעיף 30א לחוק התקשורת (בזק ושידורים), התשמ״ב-1982, לרבות מסר
          המעודד רכישת מוצר/שירות או הוצאת כספים בדרך אחרת, הנשלח באמצעי תקשורת אלקטרוניים (כגון
          SMS, דוא״ל, פקס, מערכות חיוג אוטומטיות וכד').
        </p>
        <p>
          14.2. החברה תשגר דברי פרסומת ללקוח/למשתמש מורשה רק אם התקבלה הסכמה מראש ומפורשת, או אם
          מתקיימים תנאי חריג המותר לפי דין.
        </p>
        <p>
          14.3.
          <strong
            >מובהר כי עצם ההסכמה לתקנון זה ו/או עצם ההרשמה למערכת אינם מהווים כשלעצמם "הסכמה מפורשת
            מראש" לקבלת דברי פרסומת.</strong
          >
          משלוח דברי פרסומת ייעשה רק לאחר קבלת הסכמה מפורשת, נפרדת, אקטיבית ומתועדת של הנמען, או
          בהתקיים חריג המותר לפי דין.
        </p>
        <p>
          14.4. ככל שבמסך ההרשמה/ניהול החשבון תוצג תיבת סימון ייעודית לקבלת דברי פרסומת (שאינה
          מסומנת כברירת מחדל), וסימון התיבה יבוצע באופן אקטיבי – סימון זה יהווה הסכמה מפורשת מראש
          לקבלת דברי פרסומת, בהתאם לדין.
        </p>
        <p>
          14.5. במקרים המותרים בדין, ייתכן שהחברה תהיה רשאית לשלוח דברי פרסומת גם ללא הסכמה מפורשת
          מראש, אם מתקיימים התנאים הקבועים בדין (לרבות מסירת הפרטים במסגרת התקשרות קודמת ומתן אפשרות
          סירוב בעת מסירת הפרטים ובכל הודעה).
        </p>
        <p>
          14.6. בכל דבר פרסומת תיכלל, בהתאם לדין: זיהוי ברור של השולח, פרטי יצירת קשר, ואפשרות
          הסרה/ביטול הסכמה פשוטה וברורה.
        </p>
        <p>
          14.7. הלקוח/המשתמש המורשה רשאי לבטל בכל עת הסכמה לקבלת דברי פרסומת. לאחר בקשת הסרה, החברה
          תפעל להפסקת משלוח דברי פרסומת לאותו מען בתוך זמן סביר ובהתאם לדין.
        </p>
        <p>
          14.8. לצרכי ציות, אבטחה וניהול הוכחות הסכמה/הסרה, החברה רשאית לשמור תיעוד טכני (לוגים) של
          פעולות הרשמה, הסכמות, מסרים שנשלחו ובקשות הסרה, לתקופה סבירה ובהתאם לדין.
        </p>
        <p>
          14.9. החברה רשאית לשלוח מסרים תפעוליים/שירותיים שאינם "דבר פרסומת", כגון אישורי הזמנה,
          עדכוני אספקה, התראות אבטחה, איפוס סיסמה, הודעות על שינויים במערכת, מסמכי חיוב וכד' – גם אם
          המשתמש בחר להסיר עצמו מדיוור שיווקי (בכפוף לדין).
        </p>
        <p>
          14.10. הלקוח מתחייב כי פרטי הקשר שסיפק שייכים למשתמשים המורשים מטעמו וכי הוא מוסמך להעבירם
          לצורך תפעול הקשר העסקי; הלקוח יישא באחריות לעדכן/להסיר אנשי קשר שאינם עוד מורשים.
        </p>

        <h2>15. קניין רוחני</h2>
        <p>
          15.1. כל זכויות הקניין הרוחני במערכת, עיצוב, קוד, תכנים, סימנים מסחריים ומסדי נתונים –
          שייכות לחברה ו/או לצדדים שלישיים שהרשו שימוש.
        </p>
        <p>
          15.2. אין להעתיק/להפיץ/לבצע הנדסה לאחור/לחלץ נתונים מהמערכת מעבר להרשאות שניתנו ללקוח.
        </p>

        <h2>16. הגבלת אחריות ושיפוי</h2>
        <p>
          16.1. המערכת והשירותים ניתנים "כמות שהם" (As-Is), והחברה אינה מתחייבת לזמינות רציפה או
          היעדר תקלות.
        </p>
        <p>16.2. אחריות החברה, ככל שתחול, תוגבל לנזקים ישירים בלבד ובכפוף לדין.</p>
        <p>
          16.3. הלקוח ישפה את החברה בגין תביעות/נזקים הנובעים מהפרת התקנון, שימוש אסור במערכת, או
          מצגים כוזבים מצד הלקוח/משתמשיו.
        </p>

        <h2>17. צדדים שלישיים וקישורים</h2>
        <p>
          17.1. המערכת עשויה לכלול קישורים/שירותים של צדדים שלישיים. החברה אינה אחראית לתכני צדדים
          שלישיים מעבר לאחריותה לפי דין.
        </p>

        <h2>18. שונות, דין וסמכות שיפוט</h2>
        <p>18.1. החברה רשאית להמחות זכויות/חובות לפי תקנון זה לצד שלישי.</p>
        <p>18.2. אם סעיף כלשהו ייקבע כבלתי אכיף – יתר הסעיפים יישארו בתוקף.</p>
        <p>
          18.3. על תקנון זה יחולו דיני מדינת ישראל. סמכות השיפוט הבלעדית תהיה בבתי המשפט המוסמכים
          במחוז חיפה, אלא אם הוסכם אחרת בכתב.
        </p>
      </article>
    </main>

    <!-- Footer -->
    <footer class="document-footer">
      <p>© 2024 GoFood. כל הזכויות שמורות.</p>
    </footer>
  </div>
</template>

<style scoped>
.document-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}

.document-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-color);
  padding: var(--spacing-md) var(--spacing-lg);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 800px;
  margin: 0 auto;
}

.back-link {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--text-primary);
  text-decoration: none;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: color var(--transition-fast);
}

.back-link:hover {
  color: #d97706;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  text-decoration: none;
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
}

.logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
}

.document-main {
  flex: 1;
  padding: var(--spacing-lg);
}

.document-content {
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--border-radius-lg);
  padding: var(--spacing-xl);
  line-height: 1.8;
}

.document-content h1 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-bold);
  color: var(--text-primary);
  margin: 0 0 var(--spacing-xl) 0;
  padding-bottom: var(--spacing-md);
  border-bottom: 2px solid #d97706;
}

.document-content h2 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  margin: var(--spacing-xl) 0 var(--spacing-md) 0;
}

.document-content p {
  margin: 0 0 var(--spacing-sm) 0;
  color: var(--text-secondary);
}

.document-content ul {
  margin: var(--spacing-sm) 0 var(--spacing-md) 0;
  padding-right: var(--spacing-xl);
}

.document-content li {
  margin-bottom: var(--spacing-xs);
  color: var(--text-secondary);
}

.document-content strong {
  color: var(--text-primary);
}

.document-footer {
  text-align: center;
  padding: var(--spacing-lg);
  color: var(--text-muted);
  font-size: var(--font-size-xs);
  border-top: 1px solid var(--border-color);
}

.document-footer p {
  margin: 0;
}

@media (max-width: 768px) {
  .document-content {
    padding: var(--spacing-lg);
  }

  .document-content h1 {
    font-size: var(--font-size-xl);
  }
}
</style>
